// @ts-nocheck типизация ломается с выключенной опцией strictNullChecks, которая отключается для сборки
import {Get, GetIn, MakeGet} from './get.types'
import {ObjectWithPath} from './path'

/**
 * Получаем из пути массив строк-ключей
 */
const splitPath = (path: string) => path.split(/[[.\]]+/).filter(Boolean)

const getCurry = <P extends string>(path: P) => {
  const keys = splitPath(path)

  return <T extends ObjectWithPath<P>>(obj: T): GetIn<T, P> => {
    let result = obj

    try {
      for (const key of keys) {
        // @ts-expect-error если ошибка происходит, мы её ловим
        result = result[key]
      }
      return result as GetIn<T, P>
      // если происходит ошибка (получение несуществующего свойства, 'cannot get ... of undefined') возвращаем undefined
    } catch {
      return undefined as GetIn<T, P>
    }
  }
}

/**
 * Получаем поля объекта по строке.
 * ```ts
 * typeof get('foo.bar[0]')({foo: {bar: [1]}}) === number
 * get('foo.bar[0]')({foo: {bar: [1]}}) === 1
 * ```
 */
export const get: Get = <P extends string>(...args: [path: P] | [path: P, obj: ObjectWithPath<P>]) => {
  const [path, obj] = args
  if (args.length > 1) return getCurry(path)(obj)
  return getCurry(path)
}

/**
 * Создаём геттер с фиксированным типом объекта, из которого будем получать данные.
 * Пример использования:
 * ```ts
 * const getFromData = makeGet<Data>()
 * const var = getFromData('foo.bar', data)
 * getFromData('foo.bar', notData) // error
 * ```
 */
export const makeGet = <T>(): MakeGet<T> => get as MakeGet<T>
